import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Box,
  Avatar,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      // Navigate after logout is complete
      setTimeout(() => navigate('/'), 0);
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  const isLoginPage = location.pathname === '/login';

  return (
    <AppBar position="static" className="header">
      <Toolbar>
        <Box className="logo-container" onClick={() => navigate('/')}>
          <img 
            src="/logo.svg" 
            alt="Smart Eco Card Logo" 
            className="company-logo"
          />
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        {currentUser ? (
          <Box className="user-menu">
            <IconButton
              onClick={() => navigate('/profile')}
              className="profile-button"
            >
              <Avatar
                src={currentUser.photoURL}
                alt={currentUser.displayName}
                className="user-avatar"
              >
                {currentUser.displayName?.charAt(0) || currentUser.email?.charAt(0)}
              </Avatar>
            </IconButton>
            <Button
              variant="outlined"
              color="inherit"
              onClick={handleLogout}
              className="logout-button"
            >
              Logout
            </Button>
          </Box>
        ) : !isLoginPage && (
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => navigate('/login')}
            className="header-login-button"
            sx={{ my: 'auto' }}
          >
            Sign In
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Header;
